import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAMap from 'vue-amap'

import './plugins/element.js'
import './commen/css/reset.css'

//import AmapVue from '@amap/amap-vue'

Vue.config.productionTip = false

// AmapVue.config.key = '3adf5f53e79673b66f8b6250996bdc7d'
// Vue.use(AmapVue)

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '3adf5f53e79673b66f8b6250996bdc7d',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
